import type * as THREE from "three";
import { intersectSegments } from "./intersectSegments";
import type { SelfIntersection } from "./types";

/**
 * Every crossing between non-adjacent edges. Edge `i` runs from `points[i]` to `points[i + 1]`;
 * for a loop the last edge wraps back to `points[0]`.
 */
function findSelfIntersections({ points, isLoop }: { points: ReadonlyArray<THREE.Vector3>; isLoop: boolean }): Array<SelfIntersection> {
	const pointCount = points.length;
	const edgeCount = isLoop ? pointCount : pointCount - 1;

	if (edgeCount < 3) {
		return [];
	}

	const intersections: Array<SelfIntersection> = [];

	for (let firstEdgeIndex = 0; firstEdgeIndex < edgeCount; firstEdgeIndex++) {
		for (let secondEdgeIndex = firstEdgeIndex + 2; secondEdgeIndex < edgeCount; secondEdgeIndex++) {
			// On a loop the first and last edge are adjacent through the closing vertex.
			if (isLoop && firstEdgeIndex === 0 && secondEdgeIndex === edgeCount - 1) {
				continue;
			}

			const point = intersectSegments({
				firstStart: points[firstEdgeIndex],
				firstEnd: points[(firstEdgeIndex + 1) % pointCount],
				secondStart: points[secondEdgeIndex],
				secondEnd: points[(secondEdgeIndex + 1) % pointCount],
			});

			if (point !== null) {
				intersections.push({ firstEdgeIndex, secondEdgeIndex, point });
			}
		}
	}

	return intersections;
}

export { findSelfIntersections };
